module.exports = __webpack_public_path__ + "img/wfqwt.6ce859b.png";